import {Fieldset} from "primereact/fieldset";
import React from "react";
import {Panel} from "primereact/panel";

export default function PlaylistEditorInfo() {
    return (
        <Panel header="BTS Playlist Editor - Info" toggleable collapsed={true}>
            <Fieldset className={"p-0"} legend={"General Information"} toggleable={true}>
                <div className="card-body">
                    The main purpose of the editor is to provide an overview of a playlist via graphs as well as bulk operations:
                    <ul>
                        <li>Replace all occurences of one song with another song.
                        </li>
                        <li>Delete all occurences of a song.</li>
                        <li>Add a song n times to the playlist. (or as much as possible without looping a song)</li>

                    </ul>
                    It is also possible to delete, replace one song or add it to the start or the end.
                </div>
                <p>
                    Same as for the playlist generator, if a song is on several albums <b>all covers are included</b> automatically (if the song is in the playlist multiple times).
                </p>
            </Fieldset>
            <Fieldset className={"p-0"} legend={"Loading a playlist"} toggleable={true}>
                <div className="card-body">
                    Only song by BTS and members are loaded. If a song that should be loaded is not, please let me know! There are two sources for playlists that you can load:
                </div>
                <p><b>Spotify</b>:
                    <ul>
                        <li>Both the links as shown in the browser as well as the sharing link from the app work.</li>
                        <li>The browser link ends with the id of the playlist, the id alone works as well.</li>
                    </ul>
                </p>
                <p><b>Apple Music</b>:
                    <ul>
                        <li>The link shown in a browser is your private library link and does NOT work. (ID starts with p.)</li>
                        <li>The link you get when sharing (copy link via app or menu) works! (the identifier starts with pl.)</li>
                        <li>The identifiers starting with pl. work</li>
                    </ul>
                </p>
            </Fieldset>
            <Fieldset className={"p-0"} legend={"Saving the edited playlist"} toggleable={true}>
                <div className="card-body">
                    There are two options:
                    <ul>
                        <li>A new playlist is saved.</li>
                        <li>The loaded playlist is replaced with the edited playlist.</li>
                    </ul>
                    Edits are only saved if a button is clicked, no autosave.
                </div>
                <p><b>Saving to Spotify</b>: You can only edit a playlist if you have an account. Then there are again two options.
                    <ul>
                        <li>You connected your own spotify accounts, this enables you to edit all the playlists of your accounts.</li>
                        <li>You generated a playlist on my public profile. Then you can edit the playlists you created while logged in. The playlists are listed under "My Playlists" - there you can go on the pencil Button -> Open in Editor.</li>
                    </ul>
                </p>
                <p><b>Saving to Apple Music</b>: Unfortunately, I have not found a way to edit a playlist, therefore a new playlist has to be saved to the account you connected. (See Playlist Generator Info)</p>
            </Fieldset>
        </Panel>)
}